<template>
  <b-datepicker
    :id="id"
    v-model.trim="date"
    :append-to-body="append_to_body"
    data-test="datepicker"
    :date-formatter="dateParser"
    :day-names="$tm('constants.days')"
    :disabled="disabled"
    :first-day-of-week="1"
    icon-pack="fa"
    :inline="inline"
    :max-date="maxDate"
    :min-date="minDate"
    :month-names="$tm('constants.months')"
    :size="size"
    style="margin: 0"
    :years-range="[-150, 150]"
  >
    <div class="buttons">
      <ButtonTertiary @onClick="emitDate()">
        {{ $t('select.actions.setToday') }}
      </ButtonTertiary>
      <ButtonTertiary @onClick="emitDate(null)">
        {{ $t('select.actions.reset') }}
      </ButtonTertiary>
    </div>
  </b-datepicker>
</template>

<script>
import { DATE_FORMATS, format } from '@/app/util/date_fns';

export default {
  name: 'SelectDate',
  props: {
    append_to_body: { type: Boolean, default: false },
    date_prop: { type: [String, Date], default: null },
    disabled: { type: Boolean, default: false },
    id: { type: String, default: null },
    inline: { type: Boolean, default: false },
    size: { type: String, default: '' },
    max_date_limit: { type: Number, default: 5000 },
    min_date_limit: { type: Number, default: 35000 },
  },

  data() {
    const today = new Date();

    return {
      date: null,
      maxDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() + this.max_date_limit),
      minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate() - this.min_date_limit),
    };
  },

  watch: {
    date_prop: {
      immediate: true,
      handler(newVal, oldVal) {
        if (oldVal === newVal) return;
        this.date = this.date_prop ? new Date(_.cloneDeep(this.date_prop)) : null;
      },
    },

    date(newVal) {
      if (!newVal) return;
      const new_date = this.dateToString(newVal);
      const previous_date = this.dateToString(new Date(_.cloneDeep(this.date_prop)));
      if (!this.date_prop || new_date !== previous_date) this.$emit('setDate', new_date);
    },
  },

  methods: {
    dateParser(val) {
      return format(val, DATE_FORMATS.DAY_MONTH_YEAR);
    },

    dateToString(date) {
      if (!date) return null;

      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString(10).padStart(2, 0);
      const day = date.getDate().toString(10).padStart(2, 0);

      return `${year}-${month}-${day}`;
    },

    emitDate(input) {
      let date = input;
      if (date === undefined) date = new Date();

      if (date instanceof Event) date = new Date();

      if (date === null) {
        this.$emit('setDate', null);
        return;
      }

      if (!(date instanceof Date)) {
        const parsed = new Date(date);
        if (!Number.isNaN(parsed)) date = parsed; // valid parsed date
      }

      if (!(date instanceof Date) || Number.isNaN(date.getTime())) return; // invalid -> do nothing

      this.$emit('setDate', this.dateToString(date));
    },
  },
};
</script>
